module.exports = __webpack_public_path__ + "static/media/26.7997d222.png";